export const users = [
  {
    id: 'u1',
    name: '糖果铺铺',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20cheerful%20young%20Chinese%20woman%20with%20soft%20long%20hair%2C%20warm%20honey%20orange%20blurred%20background%2C%20natural%20soft%20studio%20lighting%2C%20clean%20friendly%20editorial%20headshot&width=300&height=300&seq=hc-avatar-u1&orientation=squarish',
    bio: '生活整理爱好者，喜欢把日子过成糖。阳台种菜两年选手，分享一切让生活变甜的小事。',
    joinDate: '2023-04-18',
    following: 186,
    followers: 5420,
    postCount: 38,
    replyCount: 612,
    badges: ['生活达人', '认证博主'],
  },
  {
    id: 'u2',
    name: '山野旅人',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20sun-tanned%20young%20Chinese%20man%20wearing%20outdoor%20jacket%2C%20warm%20orange%20blurred%20background%2C%20natural%20soft%20lighting%2C%20clean%20friendly%20editorial%20headshot&width=300&height=300&seq=hc-avatar-u2&orientation=squarish',
    bio: '在路上的人。骑行、徒步、露营，去没去过的地方，把风景写成文字。',
    joinDate: '2022-09-02',
    following: 240,
    followers: 8760,
    postCount: 52,
    replyCount: 430,
    badges: ['旅行家', '优质作者'],
  },
  {
    id: 'u3',
    name: '甜点师小林',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20smiling%20young%20Chinese%20woman%20pastry%20chef%20with%20apron%2C%20warm%20cream%20colored%20blurred%20background%2C%20soft%20natural%20lighting%2C%20clean%20friendly%20editorial%20headshot&width=300&height=300&seq=hc-avatar-u3&orientation=squarish',
    bio: '烘焙工作室主理人。做过1000个舒芙蕾之后，终于敢说有点心得了。',
    joinDate: '2023-01-11',
    following: 312,
    followers: 12400,
    postCount: 64,
    replyCount: 980,
    badges: ['美食博主', '认证达人'],
  },
  {
    id: 'u4',
    name: '代码老陈',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20friendly%20middle-aged%20Chinese%20man%20with%20glasses%2C%20warm%20orange%20blurred%20background%2C%20soft%20natural%20lighting%2C%20clean%20professional%20editorial%20headshot&width=300&height=300&seq=hc-avatar-u4&orientation=squarish',
    bio: '写了十五年程序的普通工程师。喜欢把复杂的东西讲简单，也喜欢折腾家用服务器。',
    joinDate: '2021-06-21',
    following: 128,
    followers: 6890,
    postCount: 45,
    replyCount: 1204,
    badges: ['技术大牛', '社区元老'],
  },
  {
    id: 'u5',
    name: '电影票根',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20thoughtful%20young%20Chinese%20woman%20with%20bangs%20and%20small%20earrings%2C%20warm%20amber%20blurred%20background%2C%20soft%20natural%20lighting%2C%20clean%20editorial%20headshot&width=300&height=300&seq=hc-avatar-u5&orientation=squarish',
    bio: '一年看200部片的杂食影迷。记住的不是剧情，是散场时的那点情绪。',
    joinDate: '2023-07-30',
    following: 205,
    followers: 3980,
    postCount: 29,
    replyCount: 540,
    badges: ['影视评论'],
  },
  {
    id: 'u6',
    name: '云端书虫',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20calm%20young%20Chinese%20woman%20wearing%20a%20light%20knit%20sweater%2C%20warm%20beige%20blurred%20background%2C%20soft%20natural%20lighting%2C%20clean%20editorial%20headshot&width=300&height=300&seq=hc-avatar-u6&orientation=squarish',
    bio: '读书、写字、慢慢生活。偏爱拉美文学和一切有潮湿气息的句子。',
    joinDate: '2022-12-05',
    following: 176,
    followers: 4560,
    postCount: 33,
    replyCount: 388,
    badges: ['书评人'],
  },
  {
    id: 'u7',
    name: '摄影阿凯',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Chinese%20man%20holding%20a%20camera%20strap%2C%20warm%20sunset%20orange%20blurred%20background%2C%20soft%20natural%20lighting%2C%20clean%20editorial%20headshot&width=300&height=300&seq=hc-avatar-u7&orientation=squarish',
    bio: '城市扫街摄影。相机越换越小，脚步越来越慢。',
    joinDate: '2023-03-14',
    following: 290,
    followers: 7210,
    postCount: 41,
    replyCount: 356,
    badges: ['摄影达人'],
  },
  {
    id: 'u8',
    name: '游戏宅阿哲',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20relaxed%20young%20Chinese%20man%20with%20headphones%20around%20neck%2C%20warm%20orange%20blurred%20background%2C%20soft%20natural%20lighting%2C%20clean%20editorial%20headshot&width=300&height=300&seq=hc-avatar-u8&orientation=squarish',
    bio: '独立游戏爱好者，通关党。这里记录那些让我熬夜也想玩完的作品。',
    joinDate: '2023-09-19',
    following: 143,
    followers: 2870,
    postCount: 27,
    replyCount: 720,
    badges: ['游戏区'],
  },
  {
    id: 'u9',
    name: '咖啡不加糖',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20gentle%20young%20Chinese%20woman%20holding%20a%20coffee%20cup%2C%20warm%20caramel%20blurred%20background%2C%20soft%20natural%20lighting%2C%20clean%20editorial%20headshot&width=300&height=300&seq=hc-avatar-u9&orientation=squarish',
    bio: '手冲咖啡日常。可以不精致，但一定要有温度。',
    joinDate: '2024-02-08',
    following: 98,
    followers: 1920,
    postCount: 19,
    replyCount: 245,
    badges: ['生活记录'],
  },
  {
    id: 'u10',
    name: '胡同里的猫',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20serene%20young%20Chinese%20man%20with%20slight%20smile%2C%20warm%20terracotta%20blurred%20background%2C%20soft%20natural%20lighting%2C%20clean%20editorial%20headshot&width=300&height=300&seq=hc-avatar-u10&orientation=squarish',
    bio: '在城市里寻找老物件和老故事。相信传统里藏着答案。',
    joinDate: '2022-08-16',
    following: 213,
    followers: 5140,
    postCount: 36,
    replyCount: 498,
    badges: ['人文观察'],
  },
];